var _style, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconInstagram = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "IconInstagram",
  x: "0px",
  y: "0px",
  viewBox: "0 0 45.9 27.8",
  style: {
    enableBackground: "new 0 0 45.9 27.8"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0nn{fill:none;stroke:#6FC9D1;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1nn{fill:none;stroke:#6FC9D1;stroke-miterlimit:10;}\r\n\t.st2nn{fill:none;stroke:#6FC9D1;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st3nn{fill:#6FC9D1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0nn",
  d: "M42.3,1H23l0,0H3.6C3.6,1,1,1.3,1,3.4v10.4V14v10.4c0,2.2,2.6,2.4,2.6,2.4H23l0,0h19.3c0,0,2.6-0.3,2.6-2.4V14 v-0.1V3.4C44.9,1.3,42.3,1,42.3,1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st1nn",
  d: "M27.3,21.2h-8.6c-1.6,0-3-1.4-3-3V8.5c0-1.7,1.3-3,3-3h8.6c1.6,0,3,1.3,3,3v9.6C30.4,19.8,29,21.2,27.3,21.2z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "st2nn",
  cx: 22.7,
  cy: 13.7,
  r: 4.1
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  className: "st3nn",
  cx: 27.3,
  cy: 8.5,
  r: 1.1
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconInstagram.67fc1164.svg";
export { ForwardRef as ReactComponent };